import React from 'react'
import './bustemp.css'
const BusinessTemp = () => {
  const files = [
    { name: "Statuti i Biznesit", url: "/Files/Statuti.docx", type: "docx", 
      description: "This document contains the statutes of the business." },
  
    { name: "Akt Themelimi", url: "/Files/Akt Themelimi.docx", type: "docx", 
      description: "This document contains the founding act of the business." },

    { name: "Prokure Perfaqesimi", url: "/Files/Prokure.docx", type: "docx", 
      description: "A power of attorney (POA) is a legal authorization that gives the agent or attorney-in-fact the authority to act on behalf of an individual referred to as the principal. The agent may be given broad or limited authority to make decisions about the principal's property, finances, investments, or medical care." }
    
  ];
  return (
    <div className="business-temp">
      <h1>Business Templates</h1>
      <p>Download our templates and get started with your business in Albania.</p>
    <div className="file-container">

      {files.map((file, index) => (
        <a key={index} href={file.url} download className="file-card">
        <div className="file-icon">
          <img src={`${process.env.PUBLIC_URL}/Images/doc.png`} alt="File Icon" />
        </div>
        <h3 className="file-title">{file.name}</h3>
      </a>
      ))}
    </div>
    </div>
  )
}

export default BusinessTemp